import { useContext } from "react";

import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { cacheRequests } from "../../../utils/cacheRequests";
import { CreateEntityResponse } from "../../common/CreateEntityResponse";
import { CreateResolutionRequest } from "./requests/CreateResolutionRequest";
import { GetResolutionListResponse } from "./responses/GetResolutionListResponse";

const resolutionsCache = cacheRequests<GetResolutionListResponse>();

const ALL_RESOLUTIONS_CACHE_KEY = "all-resolutions";

export const useResolutionsApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const baseUrl = `${appConfigContext.ordersConfig.apiUrl}/resolution`;

    const { httpPost, httpGet } = useAuthorizedFetch();

    const getResolutionList = async (): Promise<GetResolutionListResponse> =>
        resolutionsCache.getRequest({
            requestFn: () => httpGet<GetResolutionListResponse>(`${baseUrl}/get-all`),
            key: ALL_RESOLUTIONS_CACHE_KEY,
            ttlMs: 60000
        });

    const createResolution = async (request: CreateResolutionRequest): Promise<CreateEntityResponse> => {
        resolutionsCache.evictCacheByKey(ALL_RESOLUTIONS_CACHE_KEY);

        return httpPost(`${baseUrl}/create`, request);
    };

    return {
        createResolution,
        getResolutionList
    };
};
